import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const AUDIT_TRAIL_REDUCER_NAME = "audit-trail";

const initialState = {
  selectValue: [],
  groupByValue: [],
  chartType: "count",
  chartData: null,
};

const auditTrailSlice = createSlice({
  name: AUDIT_TRAIL_REDUCER_NAME,
  initialState,
  reducers: {
    setSelectValue: (state, { payload }) => {
      state.selectValue = payload;
    },
    setGroupByValue: (state, { payload }) => {
      state.groupByValue = payload;
    },
    setChartType: (state, { payload }) => {
      state.chartType = payload;
    },
    setChartData: (state, { payload }) => {
      state.chartData = payload;
    },
    clearAuditTrail: (state) => {
      state.selectValue = initialState.selectValue;
      state.groupByValue = initialState.groupByValue;
      state.chartData = initialState.chartData;
    },
  },
});

export const {
  setSelectValue,
  setGroupByValue,
  setChartType,
  setChartData,
  clearAuditTrail,
} = auditTrailSlice.actions;

export default auditTrailSlice.reducer;

export const useSelectAuditTrailSelectValue = () =>
  useSelector((state) => state[AUDIT_TRAIL_REDUCER_NAME].selectValue);

export const useSelectAuditTrailGroupByValue = () =>
  useSelector((state) => state[AUDIT_TRAIL_REDUCER_NAME].groupByValue);

export const useSelectAuditTrailChartType = () =>
  useSelector((state) => state[AUDIT_TRAIL_REDUCER_NAME].chartType);

export const useSelectAuditTrailChartData = () =>
  useSelector((state) => state[AUDIT_TRAIL_REDUCER_NAME].chartData);
